import { setUploadAvatarModal } from '../../store/workspace/slice';
import { ResizeSquareIcon } from '../../assets/icons/common';
import { useDispatch, useSelector } from '../../store/store';
import Modal from '../../components/Modal';
import styles from './style.module.scss';
import UploadBox from '../UploadBox';
import { useState } from 'react';
import { objectURLToFile } from '../../utils/generalHelpers';
import { uploadFileThunk } from '../../store/general/thunks';
import { selectUserId } from '../../store/auth/selectors';
import { setNotification } from '../../store/general/slice';
import { getAvatarPhotoThunk } from '../../store/workspace/thunks';

const fileTypes = [".JPEG", ".JPG", ".PNG"];

export default function UploadAvatar() {
    const dispatch = useDispatch();
    const userId = useSelector(selectUserId);
    const [isLoading, setIsLoading] = useState(false);

    const onSave = async (imgUrl: string) => {
        if (!userId) return;
        setIsLoading(true);
        const file = await objectURLToFile(imgUrl, 'avatar.png', 'image/png');
        dispatch(uploadFileThunk({ fileName: `${userId}/avatar.png`, file }))
            .unwrap()
            .then(() => {
                dispatch(getAvatarPhotoThunk(`${userId}/avatar.png`))
                    .unwrap()
                    .then(() => {
                        dispatch(setUploadAvatarModal(false));
                    })
                    .catch(() => {
                        setIsLoading(false);
                        dispatch(setNotification(['Failed to get new avatar photo', 'error']))
                    })
            })
            .catch(() => {
                setIsLoading(false);
                dispatch(setNotification(['Upload failed...', 'error']))
            })
    };

    return (
        <Modal
            size='md'
            title='Upload avatar photo'
            icon={<ResizeSquareIcon />}
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setUploadAvatarModal(false))}
        >
            <UploadBox
                aspect={1}
                onSave={onSave}
                fileTypes={fileTypes}
                isSaveBtnLoading={isLoading}
            />
        </Modal>
    )
};
